import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../icon/Icon';
import Input from '../../input/Input';
import type { ContactMessageProps } from './ContactMessage.types';
import './contactMessage.scss';

const ContactMessage = ({ avatar, placeholder, iconName, iconFunction }: ContactMessageProps) => {

  return (
    <div
      className="sb-contactMessage"
      data-testid="sb-contactMessage"
    >
      <div
        className="sb-contactMessage__containerImage"
        data-testid="sb-contactMessage__containerImage"
      >
        <img
          className="sb-contactMessage__containerImage--img"
          data-testid="sb-contactMessage__containerImage--img"
          src={avatar}
          alt=""
        />
      </div>
      <div
        className="sb-contactMessage__container"
        data-testid="sb-contactMessage__container"
      >
        <Input
          placeholder={placeholder}
          iconInput="paperclip"
        />
      </div>
      <div
        className="sb-contactMessage__icon"
        data-testid="sb-contactMessage__icon"
      >
        <Icon
          onClick={iconFunction}
          iconName={iconName}
          size={16}
          className="text-neutral-04 cursor-pointer"
        />
      </div>
    </div>
  );
};

ContactMessage.propTypes = {
  /**
 * avatar
 */
  avatar: PropTypes.string,
  /**
* placeholder?
*/
  placeholder: PropTypes.string,
  /**
* IconName
*/
  iconName: PropTypes.string,
  /**
* iconFunction
*/
  iconFunction: PropTypes.func,
};

ContactMessage.defaultProps = {
  avatar: "",
  placeholder: "Escribir mensaje",
  iconName: "chevron-right",
  iconFunction: () => { }
};

export default ContactMessage;